var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41221 5.50039C7.33721 5.28372 7.22262 5.09414 7.06846 4.93164C6.91429 4.76914 6.72887 4.65039 6.51221 4.57539V1.02539C7.70387 1.14206 8.71846 1.61914 9.55596 2.45664C10.3935 3.29414 10.8705 4.30872 10.9872 5.50039H7.41221ZM5.51221 10.9754C4.22887 10.8504 3.15804 10.3129 2.29971 9.36289C1.44137 8.41289 1.01221 7.29206 1.01221 6.00039C1.01221 4.70872 1.44137 3.58789 2.29971 2.63789C3.15804 1.68789 4.22887 1.15039 5.51221 1.02539V4.57539C5.21221 4.68372 4.97054 4.86914 4.78721 5.13164C4.60387 5.39414 4.51221 5.68372 4.51221 6.00039C4.51221 6.31706 4.60387 6.60247 4.78721 6.85664C4.97054 7.11081 5.21221 7.29206 5.51221 7.40039V10.9754ZM6.51221 10.9754V7.40039C6.72887 7.32539 6.91429 7.21081 7.06846 7.05664C7.22262 6.90247 7.33721 6.71706 7.41221 6.50039H10.9872C10.8705 7.69206 10.3935 8.70664 9.55596 9.54414C8.71846 10.3816 7.70387 10.8587 6.51221 10.9754Z",
    fill: "#FF8E02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeIcon);
export default __webpack_public_path__ + "static/media/ThemeIcon.4f9d0832d2a4ba076ed327cae2d0179d.svg";
export { ForwardRef as ReactComponent };